import { Routes } from '@angular/router';
import { MVP_DEMO_OFFLINE } from './core/config/mvp-demo.config';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/login/login-page.component').then((m) => m.LoginPageComponent),
  },
  {
    path: 'admin',
    ...(MVP_DEMO_OFFLINE ? {} : { canActivate: [authGuard] }),
    loadComponent: () =>
      import('./core/layout/admin-layout.component').then((m) => m.AdminLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'coupons' },
      {
        path: 'coupons',
        loadComponent: () =>
          import('./features/admin-coupons/admin-coupons-list.component').then(
            (m) => m.AdminCouponsListComponent,
          ),
      },
      {
        path: 'coupons/new',
        loadComponent: () =>
          import('./features/admin-coupons/admin-coupon-form.component').then(
            (m) => m.AdminCouponFormComponent,
          ),
      },
      {
        path: 'coupons/:id',
        loadComponent: () =>
          import('./features/admin-coupons/admin-coupon-form.component').then(
            (m) => m.AdminCouponFormComponent,
          ),
      },
      {
        path: 'coupons/:id/redemptions',
        loadComponent: () =>
          import('./features/admin-coupons/admin-coupon-redemptions.component').then(
            (m) => m.AdminCouponRedemptionsComponent,
          ),
      },
      {
        path: 'banners',
        loadComponent: () =>
          import('./features/admin-banners/admin-banners-list.component').then(
            (m) => m.AdminBannersListComponent,
          ),
      },
      {
        path: 'banners/new',
        loadComponent: () =>
          import('./features/admin-banners/admin-banner-form.component').then(
            (m) => m.AdminBannerFormComponent,
          ),
      },
      {
        path: 'banners/:id',
        loadComponent: () =>
          import('./features/admin-banners/admin-banner-form.component').then(
            (m) => m.AdminBannerFormComponent,
          ),
      },
      {
        path: 'subscribers',
        loadComponent: () =>
          import('./features/admin-subscribers/admin-subscribers-page.component').then(
            (m) => m.AdminSubscribersPageComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
